import { useAppSelector } from 'src/redux/hooks';

import { serviceStandardsSelectorData } from './selectors';

export const useServiceStandards = () => useAppSelector(serviceStandardsSelectorData);
